import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { AUDIENCE_POINTS, NOT_NEEDED } from './salesData';
import { AUDIENCE_IMAGE_URL } from '../utils/headMeta';
export function AudienceSection() {
  return <section id="para-quien" className="bg-cream py-14 sm:py-20" data-id="element-34" data-mp="s1e1no7qri95">
      <div className="mx-auto max-w-6xl px-5" data-id="element-35" data-mp="wymmjwk9y0e3">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-center lg:gap-14" data-id="element-36" data-mp="wxbkc16h90p3">
          <div data-id="element-37" data-mp="4b09zyt2jlf3">
            <SectionTag data-id="element-38" data-mp="4ah117lec7d7">Para quién es</SectionTag>
            <h2 className="mt-4 max-w-[18ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2.4rem]" data-id="element-39" data-mp="4ba15ppunymd">
              Es para vos si querés <span className="text-gold" data-id="element-40" data-mp="e1v57soalvco">empezar</span>, no si querés
              coleccionar recetas.
            </h2>

            <ul className="mt-6 space-y-2.5" data-id="element-41" data-mp="3cqjxsiaz0bmr">
              {AUDIENCE_POINTS.map(point => <li key={point} className="flex gap-3 font-sans text-[0.89rem] leading-snug text-charcoal/85" data-id="element-42" data-mp="3hobxvzlrr421">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-43" data-mp="zbg2dhrdkmsl" />
                  {point}
                </li>)}
            </ul>

            <div className="mt-7 rounded-3xl border border-stone bg-sand p-5" data-id="element-44" data-mp="qjnxdml4e5ve">
              <p className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-45" data-mp="lkb8yxeloqqp">
                No necesitás
              </p>
              <ul className="mt-3 flex flex-wrap gap-2" data-id="element-46" data-mp="gjn7fhsqwri8">
                {NOT_NEEDED.map(item => <li key={item} className="rounded-full bg-white px-3 py-1.5 font-sans text-[0.79rem] font-medium text-taupe line-through decoration-gold decoration-2" data-id="element-47" data-mp="bmnbhzpm154u">
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <img src={AUDIENCE_IMAGE_URL} alt="Manos acomodando brownies y alfajores en una caja de postres en una cocina luminosa" loading="lazy" decoding="async" width={1000} height={1250} className="h-full w-full rounded-3xl object-cover shadow-[0_30px_60px_-34px_rgba(56,37,34,0.5)]" data-id="element-48" data-mp="3vhjtcbhzvzuj" />
        </div>
      </div>
    </section>;
}